const flagButton = document.querySelector(".header__flag-button");
const dropdown = document.querySelector(".header__flags-dropdown");

if (flagButton && dropdown) {
  flagButton.addEventListener("click", function () {
    const isExpanded = flagButton.getAttribute("aria-expanded") === "true";
    flagButton.setAttribute("aria-expanded", !isExpanded);
    dropdown.hidden = isExpanded;
  });

  // Cerrar el dropdown cuando se hace clic fuera
  document.addEventListener("click", function (event) {
    if (
      !flagButton.contains(event.target) &&
      !dropdown.contains(event.target)
    ) {
      flagButton.setAttribute("aria-expanded", "false");
      dropdown.hidden = true;
    }
  });
}
